const style = {}

export default style



// WEBPACK FOOTER //
// ./src/components/Community/partials/RevenueTable/style/ColorBlind/item.js